import React from 'react';
import styled from '@emotion/styled';
import { useIsReadOnly } from '../../context/UserContextProvider';

const ConfirmModal = ({ onClose, modalMessage, modalAction }) => {
  const isReadOnly = useIsReadOnly();
  return (
    <ConfirmContent>
      <span>{modalMessage}</span>
      <div className="actions">
        <button className="cancel" onClick={onClose}>
          Cancel
        </button>
        <button
          className={`confirm ${isReadOnly ? 'disabled' : ''}`}
          onClick={() => {
            modalAction();
            onClose();
          }}
          disabled={isReadOnly}
        >
          Confirm
        </button>
      </div>
    </ConfirmContent>
  );
};

const ConfirmContent = styled.div`
  align-items: center;
  display: flex;
  flex-flow: column;
  gap: 20px;

  span {
    color: #02222b;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.2;
  }

  .actions {
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;

    button {
      border-radius: 8px;
      cursor: pointer;
      font-weight: 600;
      height: 30px;
      transition: ease-in-out all 250ms;
      width: 100px;
      justify-content: center;
      &:hover {
        filter: brightness(0.9);
        transition: ease-in-out all 250ms;
      }
    }

    button.confirm {
      background: #02222b;
      border: none;
      color: white;
    }

    button.cancel {
      background: white;
      border: 1px solid #d0d5dd;
      color: #02222b;
    }
  }
`;

export { ConfirmModal };
export default ConfirmModal;
